export enum HttpStatusCode {
    OK = 200,
    NoContent = 204,
    BadRequest = 400,
    NotFound = 404,
}
